import Paho from 'paho-mqtt';
import CryptoJS from 'crypto-js';
import {MQTT_CONFIG} from 'src/config/params-local';
import {getUserIdentity} from 'src/components/api/interface-hhy';

// 链接状态
export const CONNECT_STATUS_WAITTING = 'waitting';
export const CONNECT_STATUS_SUCCESS = 'success';
export const CONNECT_STATUS_FAIL = 'fail';
export const CONNECT_STATUS_LOST = 'lost';
/**
 * 创建Paho.MQTT.Client
 * @return {Paho.Client}
 */
export function createClient () {
  let userIdentity = getUserIdentity();
  let client = new Paho.Client(
    MQTT_CONFIG.host, // MQTT域名
    MQTT_CONFIG.port, // WebSocket端口，如果使用HTTPS加密则配置为443,否则配置80
    MQTT_CONFIG.groupId + '@@@' + userIdentity.branchId + userIdentity.userId + userIdentity.tableNo // 客户端ClientId
  );
  return client;
}

/**
 * 生成链接配置信息
 * @param client
 * @return {{userName: string, password: (string|*), useSSL: boolean, timeout: number, onSuccess: onSuccess, onFailure: onFailure}}
 */
export function createConnectOptions () {
  let password = CryptoJS.HmacSHA1(MQTT_CONFIG.groupId, MQTT_CONFIG.secretKey).toString(CryptoJS.enc.Base64);
  let options = {
    userName: MQTT_CONFIG.accessKey,
    password: password,
    useSSL: MQTT_CONFIG.useTLS,
    timeout: 3
  };

  return options;
}

/**
 * 成功连接
 * Connection succeeded; subscribe to our topic
 * @param {Paho.MQTT.Client} mqtt
 */
export function onConnect(mqtt) {
  let topic = MQTT_CONFIG.topic;
  mqtt.subscribe(topic, {qos: 0});
}



// WEBPACK FOOTER //
// ./src/common/mqtt/mqtt.js